var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoalkeeperSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M44.5,21.41a10.85,10.85,0,0,1-1.09,1,11.29,11.29,0,0,1-7.12,2.33,11,11,0,0,1-4.91-1.26,10.82,10.82,0,0,1-2.79-2A11.27,11.27,0,0,1,27.44,6.84h0A11.8,11.8,0,0,1,28.59,5.5a14.32,14.32,0,0,1,1.34-1.15A11.26,11.26,0,0,1,44.5,5.5a11.54,11.54,0,0,1,2.12,2.95,11,11,0,0,1,1.15,4.38,11.17,11.17,0,0,1-2.32,7.49A9.63,9.63,0,0,1,44.5,21.41Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.28 12.18 37.81 8.71 33.07 9.98 31.8 14.72 35.27 18.19 40.01 16.92 41.28 12.18",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.77,12.83,45.93,11l.69-2.54",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.28,3.25l-2.44.65L37.17,2.23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.41,22.37l.43-1.62,1.61-.43",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.93,4.35l-.53,2-1.95.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3,13.71l1.86,1.86-.74,2.78",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.38,23.44l2.88-.77,2,2",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.28,
    y1: 12.18,
    x2: 45.93,
    y2: 11,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.74,
    y1: 8.81,
    x2: 38.83,
    y2: 3.9,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.28,
    y1: 10.19,
    x2: 29.4,
    y2: 6.32,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.85,
    y1: 14.64,
    x2: 27.16,
    y2: 15.57,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.32,
    y1: 18.12,
    x2: 34.26,
    y2: 22.67,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.86,
    y1: 16.77,
    x2: 43.84,
    y2: 20.75,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,9.79l3-3a1.64,1.64,0,0,0,0-2.3h0a1.63,1.63,0,0,0-2.31,0L14.89,9.23a4.42,4.42,0,0,0-1.2,2.3h0a4.33,4.33,0,0,1-1.21,2.31l-3.8,3.81,7.62,7.62,4.37-4.37a2.72,2.72,0,0,1,1.94-.81h4.85",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.45,7.29,23,5.72a1.58,1.58,0,0,1,2.22,0h0a1.57,1.57,0,0,1,0,2.23l-4,4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.3,
    y1: 16.44,
    x2: 25.7,
    y2: 16.44,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4,
    y1: 14.18,
    x2: 25.38,
    y2: 12.2,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.49,
    y1: 14.83,
    x2: 19.11,
    y2: 22.45,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.37,
    y1: 18.35,
    x2: 2.21,
    y2: 25.51,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.69,
    y1: 24.66,
    x2: 8.53,
    y2: 31.83,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,8.25,26.21,7a1.36,1.36,0,0,1,1.4-.33",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.21,31.05l3-3a1.64,1.64,0,0,1,2.3,0h0a1.63,1.63,0,0,1,0,2.31l-4.75,4.76a4.33,4.33,0,0,1-2.3,1.19h0a4.41,4.41,0,0,0-2.31,1.22l-3.81,3.8L24.73,33.7l4.37-4.37a2.72,2.72,0,0,0,.81-1.94V22.54",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.71,28.55,44.28,27a1.58,1.58,0,0,0,0-2.22h0a1.57,1.57,0,0,0-2.23,0l-4,4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.56,
    y1: 28.7,
    x2: 33.56,
    y2: 24.3,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.82,
    y1: 26.6,
    x2: 37.8,
    y2: 24.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.17,
    y1: 38.51,
    x2: 27.55,
    y2: 30.89,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.65,
    y1: 40.62,
    x2: 24.49,
    y2: 47.79,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.34,
    y1: 34.31,
    x2: 18.17,
    y2: 41.47,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75,25.05,43,23.78a1.34,1.34,0,0,0,.33-1.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalkeeperSave);
export default __webpack_public_path__ + "static/media/GOALKEEPER_SAVE.fe70e88429a8b80f0adeed3185c7aa14.svg";
export { ForwardRef as ReactComponent };